import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[90vh] flex items-center overflow-hidden bg-background-50">
      {/* Background image collage */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-[6%] right-[4%] w-[250px] h-[310px] rounded-[32px] overflow-hidden opacity-80 rotate-[-3deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20product%20photography%20of%20light%20grey%20canvas%20sneakers%20on%20warm%20sand%20colored%20background%2C%20clean%20studio%20lighting%2C%20soft%20natural%20shadows%2C%20editorial%20style%2C%20modern%20Scandinavian%20aesthetic%2C%20elevated%20product%20isolation%20with%20gentle%20depth%20of%20field&width=500&height=620&seq=hero-v2-01&orientation=portrait"
            alt="Trending canvas sneakers"
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
        </div>
        <div className="absolute top-[14%] right-[21%] w-[190px] h-[240px] rounded-[28px] overflow-hidden opacity-70 rotate-[2deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20product%20photography%20of%20an%20olive%20green%20oversized%20pullover%20hoodie%20neatly%20folded%20on%20light%20sand%20backdrop%2C%20minimal%20composition%2C%20soft%20diffused%20daylight%2C%20clean%20aesthetic%2C%20contemporary%20fashion%20editorial%20with%20warm%20undertones&width=380&height=480&seq=hero-v2-02&orientation=portrait"
            alt="Olive green hoodie"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute bottom-[10%] right-[9%] w-[210px] h-[270px] rounded-[30px] overflow-hidden opacity-75 rotate-[5deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20navy%20blue%20structured%20cap%20on%20warm%20sand%20surface%2C%20clean%20studio%20lighting%2C%20soft%20shadows%2C%20simple%20elegant%20composition%2C%20modern%20minimal%20style%2C%20fashion%20editorial&width=420&height=540&seq=hero-v2-03&orientation=portrait"
            alt="Navy structured cap"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute top-[33%] right-[29%] w-[160px] h-[200px] rounded-[24px] overflow-hidden opacity-65 rotate-[-6deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20tan%20leather%20crossbody%20bag%20on%20warm%20sand%20background%2C%20soft%20natural%20window%20light%2C%20simple%20elegant%20styling%2C%20modern%20editorial%20fashion%20aesthetic%2C%20minimal%20composition&width=320&height=400&seq=hero-v2-04&orientation=portrait"
            alt="Tan leather crossbody bag"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute top-[48%] right-[37%] w-[145px] h-[185px] rounded-[22px] overflow-hidden opacity-60 rotate-[1deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20product%20photography%20of%20round%20tortoiseshell%20sunglasses%20on%20warm%20sand%20backdrop%2C%20minimal%20composition%2C%20soft%20diffused%20light%2C%20clean%20elegant%20aesthetic%2C%20high%20quality%20editorial%20style&width=290&height=370&seq=hero-v2-05&orientation=portrait"
            alt="Tortoiseshell sunglasses"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute bottom-[23%] right-[24%] w-[185px] h-[235px] rounded-[26px] overflow-hidden opacity-65 rotate-[-4deg]">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20minimalist%20silver%20watch%20with%20fabric%20strap%20on%20warm%20sand%20surface%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20modern%20aesthetic%2C%20editorial%20style%20with%20gentle%20shadows&width=370&height=470&seq=hero-v2-06&orientation=portrait"
            alt="Silver fabric strap watch"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/92 to-transparent w-[58%]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 max-w-[1440px] mx-auto">
        <div className="max-w-[44%]">
          <p className="text-accent-500 text-sm font-medium tracking-wide mb-4 uppercase">
            Updated Daily &middot; Community Verified
          </p>
          <h1 className="font-heading text-foreground-950 leading-[1.05] mb-6">
            <span className="block text-[44px] md:text-[52px] font-light italic">
              Discover
            </span>
            <span className="block text-[56px] md:text-[68px] font-bold">
              Pandabuy
            </span>
            <span className="block text-[56px] md:text-[68px] font-bold">
              Sheet Finds
            </span>
          </h1>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-[440px]">
            Curated daily. Community verified. The fastest way to browse
            10,000+ fashion items without endless scrolling.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer group"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <Link
              to="/article/best-pandabuy-spreadsheet-sneakers-2026"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-full border-2 border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Shopping Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Trust strip */}
      <div className="absolute bottom-0 left-0 right-0 bg-background-50/80 backdrop-blur-sm border-t border-background-200/70">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-4 flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {[
            { label: "Updated Daily", icon: "ri-refresh-line" },
            { label: "10,000+ Curated Items", icon: "ri-check-double-line" },
            { label: "Community Verified Lists", icon: "ri-shield-check-line" },
            { label: "Fast & Mobile Optimized", icon: "ri-smartphone-line" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm text-foreground-600">
              <i className={`${item.icon} text-accent-500 text-base`}></i>
              <span className="whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}